import { render, staticRenderFns } from "./GradingBlock.vue?vue&type=template&id=28f600d5&scoped=true"
import script from "./GradingBlock.vue?vue&type=script&lang=js"
export * from "./GradingBlock.vue?vue&type=script&lang=js"
import style0 from "./GradingBlock.vue?vue&type=style&index=0&id=28f600d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f600d5",
  null
  
)

export default component.exports